import React from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onExport, 
  onReset,
  isExporting = false 
}) => {
  const timeRangeOptions = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const severityOptions = [
    { value: 'all', label: 'All Severities' },
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'open', label: 'Open' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'closed', label: 'Closed' }
  ];

  const teamOptions = [
    { value: 'all', label: 'All Teams' },
    { value: 'soc-team', label: 'SOC Team' },
    { value: 'incident-response', label: 'Incident Response' },
    { value: 'threat-intel', label: 'Threat Intelligence' },
    { value: 'forensics', label: 'Digital Forensics' }
  ];

  const exportOptions = [
    { value: 'pdf-summary', label: 'PDF Summary' },
    { value: 'pdf-detailed', label: 'PDF Detailed' },
    { value: 'csv-data', label: 'CSV Data' },
    { value: 'excel-report', label: 'Excel Report' }
  ];

  const handleExport = (format) => {
    onExport(format);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-light mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Report Filters</h3>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onReset}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Reset
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Select
          label="Time Range"
          options={timeRangeOptions}
          value={filters?.timeRange}
          onChange={(value) => onFilterChange('timeRange', value)}
        />

        <Select
          label="Severity"
          options={severityOptions}
          value={filters?.severity}
          onChange={(value) => onFilterChange('severity', value)}
        />

        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Team"
          options={teamOptions}
          value={filters?.team}
          onChange={(value) => onFilterChange('team', value)}
        />
      </div>
      {filters?.timeRange === 'custom' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <Input
            label="Start Date"
            type="date"
            value={filters?.startDate}
            onChange={(e) => onFilterChange('startDate', e?.target?.value)}
          />
          <Input
            label="End Date"
            type="date"
            value={filters?.endDate}
            onChange={(e) => onFilterChange('endDate', e?.target?.value)}
          />
        </div>
      )}
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>Reports are generated based on current filter settings</span>
        </div>

        <div className="flex items-center space-x-2">
          {exportOptions?.map((option) => (
            <Button
              key={option?.value}
              variant="outline"
              size="sm"
              onClick={() => handleExport(option?.value)}
              loading={isExporting}
              iconName="Download"
              iconPosition="left"
            >
              {option?.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;